const techCategories = {
    // Frontend Technologies
    'HTML': { category: 'Frontend' },
    'CSS': { category: 'Frontend' },
    'JavaScript': { category: 'Frontend' },
    'React': { category: 'Frontend' },
    'Bootstrap': { category: 'Frontend' },
    'Material-UI': { category: 'Frontend' },

    // Backend Technologies  
    'Python': { category: 'Backend' },
    'Flask': { category: 'Backend' },
    'FastAPI': { category: 'Backend' },

    // Database & Query Languages
    'SQL': { category: 'Database & Query' },
    'SQLAlchemy': { category: 'Database & Query' },

    // AI/ML Technologies
    'Google Gemini': { category: 'AI/ML' },
    'Gemini AI': { category: 'AI/ML' }, // Alternative name
    'LangChain': { category: 'AI/ML' },

    // Tools & Platforms
    'GitHub': { category: 'Tools & Platforms' },
    'Docker': { category: 'Tools & Platforms' },
    'Render': { category: 'Tools & Platforms' },
    'Squarespace': { category: 'Tools & Platforms' },

    // APIs & Services
    'API': { category: 'APIs & Services' },

    // Data Visualization
    'Chart.js': { category: 'Data Visualization' },
    'Leaflet.js': { category: 'Data Visualization' },

    // Other Technologies
    'Twine': { category: 'Other' },
    'SEO': { category: 'Other' }
};

export default techCategories;